"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingHandler = void 0;
const React = require("react");
const react_1 = require("react");
const MarketingContext_1 = require("../../contexts/MarketingContext");
const useRetrieveMarketingItems_1 = require("../../hooks/useRetrieveMarketingItems");
const MarketingHandler = ({ children }) => {
    const { mutate: retrieveMarketingItems, error: retrieveMarketingItemsError, isLoading: isRetrievingMarketingItems } = (0, useRetrieveMarketingItems_1.useRetrieveMarketingItems)({
        onSuccess: (marketingItems) => {
            return marketingItems;
        },
        onSettled: () => {
            return [];
        },
        onError: (error) => console.error(error)
    });
    const contextValue = (0, react_1.useMemo)(() => ({
        retrieveMarketingItems,
        retrieveMarketingItemsError,
        isRetrievingMarketingItems
    }), [
        retrieveMarketingItems,
        retrieveMarketingItemsError,
        isRetrievingMarketingItems
    ]);
    return (React.createElement(MarketingContext_1.MarketingContext.Provider, { value: contextValue }, children));
};
exports.MarketingHandler = MarketingHandler;
//# sourceMappingURL=index.js.map